import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { Helmet } from 'react-helmet';
import Footer from 'components/Footer';

import CollectionItem from 'components/CollectionItem';
import Modal from 'components/Modal';
import Checkbox from 'components/common/Checkbox';
import ClipboardButton from 'react-clipboard.js';

import cn from 'classnames';
import styles from './Collection.scss';
import nothingFound from 'assets/images/nothingfound@2x.png';
import iconLink from 'assets/images/icons/icon-link-dark.svg';
import iconCheck from 'assets/images/icons/check-icon.svg';

import { loadCollection, switchInfoAccess } from 'actions/collections';
import { setPopUp } from 'actions/environment';
import tracker from '../../services/tracker';
import { useTranslation, withTranslation } from 'react-i18next';
import { LotsValues, makeBase64, firstLetterToUpper } from '../Building/Main/helper';
import { Select } from '../Login/FormRegistration/Select';


const Collection = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [values, setValues] = useState({
    nameAddress: true,
    description: true,
    characteristics: true,
    communications: true,
    checkout: true,
    payment: true,
    map: true,
    lots: LotsValues[0]
  });

  const handleChange = (name, value) => {
    if (name === 'lots') {
      const event = value === 'Показывать все лоты'
        ? 'Web_ShareCollectionDialog_Lots_0'
        : value === 'Только отобранные лоты'
          ? 'Web_ShareCollectionDialog_Lots_1'
          : 'Web_ShareCollectionDialog_Lots_2';

      tracker.sendEvent(event);
    } else {
      tracker.sendEvent(`Web_ShareCollectionDialog_${firstLetterToUpper(name)}`, {
        selected: value
      });
    }

    setValues(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  useEffect(() => {
    dispatch(loadCollection({ referal: props.match.params.referal }));
  }, []);

  const handleClipboardClick = () => {
    tracker.sendEvent('Web_ShareCollectionDialog_CopyButton');
    setShowNotification(true);
    setTimeout(
      () => setShowNotification(false), 5000
    );
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const showLinkModal = () => {
    tracker.sendEvent('Web_Selections_Share');
    setShowModal(true);
  };

  const handleInputFocus = (e) => {
    e.target.selectionStart = 0;
    e.target.selectionEnd = e.target.value.length;
    tracker.sendEvent('Web_ShareCollectionDialog_Link');
  };

  const [shareUrl, setShareUrl] = useState('');
  useEffect(() => {
    makeBase64({
      r: props.match.params.referal,
      values
    }).then((hash) => setShareUrl(
      `${location.origin}/ncollection/${hash}`
    ));
  }, [values]);

  const { className, buildings, selection: { name } } = props;

  return (
    <React.Fragment>
      <Helmet>
        <title>
          {t('components.collection.title', { name })}
        </title>
      </Helmet>
      <div className={styles.CollectionWrap}>
        <div className={cn(styles.Collection, className)}>
          <div className={styles.Container}>
            <div className={styles.TitleBlock}>
              <div className={styles.TitleBlockLeft}>
                <p className={styles.Title}>
                  <Link to="/collections">
                    {t('components.collection.myCollections')}
                  </Link> / {name}
                </p>
                {buildings && (
                <span className={styles.ObjectsCount}>
                  {buildings.length || 0} {t('common.jk')}
                </span>
              )}
              </div>
              {buildings && (
                <div onClick={showLinkModal} className={cn(styles.SendCollectionBtn, 'button-primary', 'button-primary--lg')}>
                  {t('components.collection.sendCollection')}
                </div>
              )}
              <Modal
                handleClose={handleClose}
                isOpen={showModal}
                title={t('components.collection.sendCollection')}
                contentStyle={{
                  width: '583px',
                  margin: 'auto'
                }}
              >
                <div className={styles.Modal}>
                  <Select
                    style={{ marginBottom: 16, width: 280 }}
                    id="lots"
                    inputStyle={{ fontSize: 15 }}
                    placeholder="—"
                    value={values.lots}
                    options={LotsValues}
                    onChange={(value) => handleChange('lots', value)}
                  />
                  <p className={styles.ModalDescription}>
                    Какие разделы будут видны по ссылке
                  </p>
                  <div className={styles.ModalCheckboxes}>
                    <Checkbox
                      checked={values.nameAddress}
                      handle={(value) => handleChange('nameAddress', value)}
                      text={'Название и адрес'}
                    />
                    <Checkbox
                      checked={values.description}
                      handle={(value) => handleChange('description', value)}
                      text={'Описание и преимущества'}
                    />
                    <Checkbox
                      checked={values.characteristics}
                      handle={(value) => handleChange('characteristics', value)}
                      text={'Общие характеристики'}
                    />
                    <Checkbox
                      checked={values.communications}
                      handle={(value) => handleChange('communications', value)}
                      text={'Коммуникации'}
                    />
                    <Checkbox
                      checked={values.checkout}
                      handle={(value) => handleChange('checkout', value)}
                      text={'Оформление'}
                    />
                    <Checkbox
                      checked={values.payment}
                      handle={(value) => handleChange('payment', value)}
                      text={'Оплата'}
                    />
                    <Checkbox
                      checked={values.map}
                      handle={(value) => handleChange('map', value)}
                      text={'Карта'}
                    />
                  </div>
                  <p className={styles.ModalDescription}>
                    {t('components.collection.sendLink')}
                  </p>
                  <div className={styles.SendCollectionInputWrap}>
                    <img src={iconLink} alt="" />
                    <input readOnly value={shareUrl} className={styles.SendCollectionInput} onFocus={handleInputFocus} />
                  </div>
                  <ClipboardButton className={cn(styles.SendCollectionBtn, 'button-primary', 'button-primary--sm')} data-clipboard-text={shareUrl} onClick={handleClipboardClick}>
                    {t('components.collection.copy')}
                  </ClipboardButton>
                  {showNotification && (
                  <span className={styles.ModalNotification}>
                    <img src={iconCheck} alt={t('components.collection.copied')} /> {t('components.collection.copied')}
                  </span>
                    )}
                </div>
              </Modal>
            </div>
            <div className={styles.CollectionItems}>
              {buildings && buildings.length ? (
                    buildings.length ? (
                      <div>
                        {
                          buildings && buildings.map(
                            (building, i) => (
                              <CollectionItem building={building} key={building.id + (building.comment || i)} />
                            )
                          )
                        }
                      </div>
                    ) : (null)
                  ) : (
                    <div className={styles.NotFoundBlock}>
                      <div className={styles.NotFoundMain}>
                        <p className={styles.NotFoundTitle}>
                          {t('components.collection.emptyCollection')}
                        </p>
                        <p className={styles.NotFoundText}>
                          {t('components.collection.description')}
                        </p>
                        <Link to="/" className={cn(styles.NotFoundBtn, 'button-primary', 'button-primary--md')}>
                          {t('components.collection.goToList')}
                        </Link>
                      </div>
                      <div className={styles.NotFoundImage}>
                        <img src={nothingFound} alt="nothing found" />
                      </div>
                    </div>
                  )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default connect(
  state => ({
    ...state.collection,
    // userUid: state.profile.hash,
    collections: state.collections.data
  }),
  { loadCollection, switchInfoAccess, setPopUp }
)(withTranslation()(Collection));



// WEBPACK FOOTER //
// ./src/components/Collection/Collection.js